module.exports = __webpack_public_path__ + "img/app.005b71b3.svg";